
import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

// Bandera interna para modo prelanzamiento
const MODO_PRELAUNCH = true;

// Lista de palabras para el carrusel
const PALABRAS_CARRUSEL = [
  'Consciencia',
  'Mente',
  'Calma',
  'Claridad',
  'Enfoque',
  'Foco',
  'Paz interior',
  'Equilibrio',
  'Energía',
  'Vitalidad',
  'Bienestar',
  'Serenidad',
  'Alegría',
  'Gratitud',
  'Confianza',
  'Autoconfianza',
  'Autoestima',
  'Amor propio',
  'Poder personal',
  'Presencia',
  'Atención plena',
  'Dirección',
  'Visión',
  'Propósito',
  'Propósito claro',
  'Sentido',
  'Sentido de vida',
  'Determinación',
  'Disciplina',
  'Motivación',
  'Resiliencia',
  'Valentía',
  'Coraje',
  'Templanza',
  'Paciencia',
  'Compasión',
  'Empatía',
  'Creatividad',
  'Intuición',
  'Sabiduría',
  'Orden',
  'Estructura',
  'Hábitos',
  'Hábitos sanos',
  'Productividad',
  'Rendimiento',
  'Tiempo',
  'Libertad',
  'Descanso',
  'Sueño reparador',
  'Límites',
  'Límites sanos',
  'Comunicación',
  'Relaciones',
  'Conexión',
  'Armonía',
  'Familia',
  'Pareja',
  'Apoyo',
  'Comunidad',
  'Tribu',
  'Autocuidado',
  'Regulación emocional',
  'Calma mental',
  'Presencia plena',
  'Espíritu',
  'Alma',
  'Vibración',
  'Frecuencia',
  'Luz',
  'Esencia',
  'Voz interior',
  'Niño interior',
  'Esperanza',
  'Ilusión',
  'Estabilidad',
  'Fortaleza',
  'Fuerza',
  'Fluidez',
  'Abundancia',
  'Prosperidad',
  'Carrera',
  'Liderazgo',
  'Influencia',
  'Carisma',
  'Magnetismo',
  'Claridad mental',
  'Autoaceptación'
];

// Palabras que requieren "tus" en lugar de "tu"
const PALABRAS_PLURAL = [
  'Límites',
  'Límites sanos',
  'Hábitos',
  'Hábitos sanos',
  'Relaciones'
];

export default function HeroSection() {
  const handlePreRegisterClick = () => {
    // Scroll suave hacia el formulario en la sección programa
    const formularioSection = document.getElementById('formulario-prelanzamiento');
    if (formularioSection) {
      formularioSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleMoreInfoClick = () => {
    const problemSection = document.getElementById('problema');
    problemSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleGradientClick = () => {
    const programSection = document.getElementById('programa');
    programSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const [isVisible, setIsVisible] = useState(true);
  const [palabraActual, setPalabraActual] = useState(0);
  const [fadeClass, setFadeClass] = useState('opacity-100');

  // Función para determinar si usar "tu" o "tus"
  const getArticulo = (palabra: string) => {
    return PALABRAS_PLURAL.includes(palabra) ? 'tus' : 'tu';
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      setIsVisible(scrolled < 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Efecto para el carrusel de palabras
  useEffect(() => {
    const interval = setInterval(() => {
      // Iniciar fade out
      setFadeClass('opacity-0');
      
      // Después de 500ms cambiar la palabra y hacer fade in
      setTimeout(() => {
        setPalabraActual((prev) => (prev + 1) % PALABRAS_CARRUSEL.length);
        setFadeClass('opacity-100');
      }, 500);
    }, 3000); // Cambiar cada 3 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section 
        id="inicio"
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/09c325b0764ea867f9736aeca7f704e4.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div 
          className="absolute inset-0 bg-gradient-to-r from-white/20 via-purple-200/30 to-white/20 animate-pulse cursor-pointer hover:from-white/30 hover:via-purple-200/40 hover:to-white/30 transition-all duration-300"
          onClick={handleGradientClick}
          title="Ir al Ecosistema Experiencia NEO"
        ></div>

        {/* Banner de prelanzamiento - Solo visible en desktop, esquina superior derecha */}
        <div className="hidden lg:block absolute top-8 right-8 z-20 max-w-sm">
          <div className="bg-gradient-to-r from-green-100 to-blue-100 rounded-xl p-4 border-l-4 border-green-400 text-center shadow-lg">
            <div className="flex items-center justify-center mb-3">
              <i className="ri-gift-line text-green-600 text-xl mr-2"></i>
              <span className="font-bold text-gray-900 text-sm">Prelanzamiento exclusivo</span>
            </div>
            <div className="flex justify-center mb-3">
              <button 
                onClick={handleGradientClick}
                className="flex flex-col items-center bg-gradient-to-r from-gray-900 to-[#6607a5] hover:from-[#6607a5] hover:to-gray-900 text-white rounded-lg p-3 shadow-lg hover:shadow-xl w-full transition-all duration-300 cursor-pointer transform hover:scale-105"
              >
                <div className="text-center">
                  <div className="font-bold text-yellow-400 text-sm">NEO 365 - Acceso Total</div>
                  <div className="text-gray-200 text-xs">Una mejor versión de tí día a día</div>
                </div>
                <div className="text-center mt-2">
                  <div className="text-yellow-400 font-bold text-xs">Cupo Fundador</div>
                  <div className="text-xs text-gray-300">Últimas Plazas</div>
                </div>
              </button>
            </div>
            <div className="text-xs text-gray-600">
              🚨PLAZAS LIMITADAS!
            </div>
          </div>
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <div className="w-full max-w-7xl mx-auto">
            
            {/* Layout principal: Móvil vertical, Desktop horizontal */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-screen py-8 lg:py-12">
              
              {/* Columna izquierda - Contenido de texto */}
              <div className="text-left text-gray-800 space-y-6 lg:space-y-8 order-2 lg:order-1">
                
                {/* Texto superior pequeño */}
                <div className="text-xs sm:text-sm uppercase tracking-wider text-gray-600 font-medium">
                  Para tí, que quieres hacerlo fácil, real y divertido. Si el crecimiento personal te sonó a cuento, este sí va en serio.
                </div>

                {/* Título principal */}
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light leading-tight tracking-tight drop-shadow-lg">
                  Transforma {getArticulo(PALABRAS_CARRUSEL[palabraActual])}
                  <span 
                    className={`block font-thin bg-gradient-to-r from-[#6607a5] to-purple-600 bg-clip-text text-transparent drop-shadow-2xl transition-opacity duration-500 min-h-[1.2em] ${fadeClass}`}
                  >
                    {PALABRAS_CARRUSEL[palabraActual]}
                  </span>
                </h1>

                {/* Subtítulo descriptivo */}
                <p className="text-lg sm:text-xl lg:text-2xl text-gray-700 leading-relaxed font-light max-w-lg">
                  En Neo te lo explicamos fácil y lo pruebas en tu día a día con micro-retos y una comunidad cercana. Sin dogmas ni humo. Únete y crea una Mentalidad imparable que te Impulse al Éxito
                </p>

                {/* Botones de acción */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-4">
                  <Button 
                    variant="primary" 
                    size="lg" 
                    className="bg-gradient-to-r from-[#6607a5] to-purple-700 hover:from-purple-700 hover:to-[#6607a5] text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm"
                    onClick={handlePreRegisterClick}
                  >
                    <i className="ri-gift-line text-lg mr-2"></i>
                    QUIERO FORMAR PARTE
                  </Button>
                  
                  <Button 
                    variant="secondary" 
                    size="lg" 
                    className="bg-white/80 hover:bg-white text-gray-800 font-medium py-3 sm:py-4 px-6 sm:px-8 rounded-full border border-gray-300 hover:border-gray-400 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap text-sm"
                    onClick={handleMoreInfoClick}
                  >
                    Más información
                  </Button>
                </div>

                {/* Testimonios/Social proof */}
                <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4 pt-4 lg:pt-6">
                  <div className="flex -space-x-2">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 border-2 border-white"></div>
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-blue-400 to-purple-400 border-2 border-white"></div>
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-green-400 to-blue-400 border-2 border-white"></div>
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-yellow-400 to-orange-400 border-2 border-white flex items-center justify-center text-white text-xs font-bold">
                      +500
                    </div>
                  </div>
                  <div className="text-sm text-gray-600">
                    <div className="font-medium">Más de 500 personas transformadas</div>
                    <div className="flex items-center">
                      <span className="text-yellow-500">★★★★★</span>
                      <span className="ml-1">4.9/5 valoración</span>
                    </div>
                  </div>
                </div>

              </div>

              {/* Columna derecha - Video */}
              <div className="flex justify-center lg:justify-end order-1 lg:order-2">
                <div className="w-full max-w-lg lg:max-w-2xl">
                  <div className="relative aspect-video bg-gradient-to-br from-gray-100 to-purple-50 rounded-xl lg:rounded-2xl overflow-hidden shadow-xl lg:shadow-2xl border border-gray-200">
                    {/* Video de Google Drive */}
                    <iframe 
                      src="https://drive.google.com/file/d/1biLE_zlJwM5_EdWta-fXpnFj3hqhAcuW/preview"
                      className="w-full h-full"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Video de presentación Experiencia NEO"
                    ></iframe>
                  </div>
                </div>
              </div>

            </div>

            {/* Sección inferior - Oferta especial - Solo visible en móviles */}
            <div className="lg:hidden absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 w-full max-w-4xl px-4 sm:px-6">
              <div className="bg-gradient-to-r from-green-100 to-blue-100 rounded-xl p-4 sm:p-6 border-l-4 border-green-400 text-center shadow-lg">
                <div className="flex flex-col sm:flex-row items-center justify-center mb-3 sm:mb-4">
                  <i className="ri-gift-line text-green-600 text-xl sm:text-2xl mb-2 sm:mb-0 sm:mr-3"></i>
                  <span className="font-bold text-gray-900 text-base sm:text-lg text-center">Prelanzamiento exclusivo - Descuento de por vida</span>
                </div>
                <div className="flex justify-center mb-3 sm:mb-4">
                  <button 
                    onClick={handleGradientClick}
                    className="flex flex-col sm:flex-row items-center justify-between bg-gradient-to-r from-gray-900 to-[#6607a5] hover:from-[#6607a5] hover:to-gray-900 text-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-lg hover:shadow-xl max-w-md w-full transition-all duration-300 cursor-pointer transform hover:scale-105"
                  >
                    <div className="text-center sm:text-left mb-2 sm:mb-0">
                      <div className="font-bold text-yellow-400 text-base sm:text-lg">NEO 365 - Acceso Total</div>
                      <div className="text-gray-200 text-sm">Una mejor versión de tí día a día</div>
                    </div>
                    <div className="text-center sm:text-right">
                      <div className="text-yellow-400 font-bold text-sm">Cupo Fundador</div>
                      <div className="text-xs text-gray-300">Últimas Plazas</div>
                    </div>
                  </button>
                </div>
                <div className="text-xs sm:text-sm text-gray-600">
                  🚨PLAZAS LIMITADAS - EL PRECIO AUMENTARÁ A 49€ PRONTO!
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Degradado de transición suave hacia la siguiente sección */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent via-gray-50/50 to-gray-50 pointer-events-none"></div>
      </section>
    </>
  );
}
